module.exports = __webpack_public_path__ + "static/media/diamond-2-company.b3b147c9.png";